import React from "react";
import { getCardImage } from "../resultVisuals/cardAssets";

const WINNER_IMG = `${import.meta.env.BASE_URL}img/winner.png`;

/**
 * Reference result body for Casino War (war): six player cards 1–6 (trophy next to every winner in
 * `win` "1,2,5"), the dealer card "D" (cards[6]) and rdesc "winner#color#oddeven#suit" (each "a~b").
 */
export default function WarResultBody({ t1 }) {
  const cards = t1?.card ? String(t1.card).split(",").map((c) => c.trim()) : [];
  const winners = t1?.win ? String(t1.win).split(",") : [];
  const desc = t1?.rdesc ? String(t1.rdesc).split("#") : [];
  const part = (i, j) => String(desc[i] ?? "").split("~")[j];

  const item = (label, idx, isDealer = false) => (
    <div className="casino-open-result-item">
      <h4 className={isDealer ? "text-warning" : undefined}>{label}</h4>{" "}
      <div className="casino-result-cards">
        <div className="casino-result-cards-item-container">
          <div className="casino-result-cards-item">
            <img src={getCardImage(cards[idx])} alt="" />
          </div>
          {!isDealer && (
            <>
              {" "}
              {winners.includes(String(idx + 1)) && (
                <div className="casino-result-cards-item">
                  <img src={WINNER_IMG} className="winner-icon" alt="" />
                </div>
              )}
            </>
          )}
        </div>
      </div>
    </div>
  );

  return (
    <div className="row row5 war-result">
      <div className="col-12 col-lg-6">
        <div className="casino-open-result">
          {[0, 1, 2, 3, 4, 5].map((i) => (
            <React.Fragment key={i}>
              {item(String(i + 1), i)}{" "}
            </React.Fragment>
          ))}
          {item("D", 6, true)}
        </div>
      </div>{" "}
      <div className="col-12 col-lg-6">
        {desc.length > 0 && (
          <div className="casino-result-desc">
            <div className="casino-result-desc-item">
              <div>Winner</div> <div>{desc[0]}</div>
            </div>{" "}
            <div className="casino-result-desc-item">
              <div>Color</div> <div>{part(1, 0)}</div>
            </div>{" "}
            <div className="casino-result-desc-item">
              <div /> <div>{part(1, 1)}</div>
            </div>{" "}
            <div className="casino-result-desc-item">
              <div>Odd/Even</div> <div>{part(2, 0)}</div>
            </div>{" "}
            <div className="casino-result-desc-item">
              <div /> <div>{part(2, 1)}</div>
            </div>{" "}
            <div className="casino-result-desc-item">
              <div>Suit</div> <div>{part(3, 0)}</div>
            </div>{" "}
            <div className="casino-result-desc-item">
              <div /> <div>{part(3, 1)}</div>
            </div>
          </div>
        )}
      </div>
    </div>
  );
}
